import React, { useState, useEffect } from "react"; // 1. Adicionado useEffect
import {
  Box,
  Button,
  CardContent,
  Typography,
  Stack,
  Avatar,
  IconButton,
  Grid,
  alpha,
  Tooltip,
} from "@mui/material";
import { useTheme } from "@emotion/react";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import SendIcon from "@mui/icons-material/Send";
import CloseIcon from "@mui/icons-material/Close";
import useStyles from "./styles";
import api from "../../services/api";
import apiCliente from "../../services/apiCliente";
import { LoadingButton } from "@mui/lab";
import { InsertDriveFileOutlined } from "@mui/icons-material";
import FileDropzone from "./fileDropzone";

export default function UploadAnexo({
  idAtendimento,
  setIsAddAnexo,
  isAddAnexo,
  setTicketDetails = () => { },
  setSnackbar = () => { },
  isCliente = false,
}) {
  const [files, setFiles] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [dragActive, setDragActive] = useState(false);

  const theme = useTheme();
  const styles = useStyles(theme);

  // Adiciona arquivos (sem remover duplicatas)
  const addFiles = (novosArquivos) => {
    setFiles((prev) => [...prev, ...Array.from(novosArquivos)]);
  };

  // ----------------------------------------------------------------
  // NOVA LÓGICA: Monitorar o CTRL+V (Paste)
  // ----------------------------------------------------------------
  useEffect(() => {
    const handlePaste = (event) => {
      // Verifica se existe algo na área de transferência
      if (event.clipboardData && event.clipboardData.items) {
        const items = event.clipboardData.items;
        const pastedFiles = [];

        // Itera sobre os itens colados
        for (let i = 0; i < items.length; i++) {
          // Se o item for um arquivo (ex: imagem de print)
          if (items[i].kind === "file") {
            const file = items[i].getAsFile();

            // Renomear o arquivo para evitar nomes genéricos como "image.png"

            if (file) {
              const newFile = new File(
                [file],
                `print_${new Date().getTime()}.png`,
                { type: file.type },
              );
              pastedFiles.push(newFile);
            }
          }
        }

        // Se houver arquivos válidos, adiciona ao state
        if (pastedFiles.length > 0) {
          event.preventDefault(); // Evita comportamento padrão se houver arquivo
          addFiles(pastedFiles);
        }
      }
    };

    // Adiciona o ouvinte no documento inteiro quando o componente monta
    document.addEventListener("paste", handlePaste);

    // Remove o ouvinte quando o componente desmonta
    return () => {
      document.removeEventListener("paste", handlePaste);
    };
  }, []); // Array vazio garante que execute apenas na montagem/desmontagem

  // ----------------------------------------------------------------

  // Seleção manual
  const handleFileChange = (event) => {
    addFiles(event.target.files);
  };

  // Drag & Drop
  const handleDragOver = (event) => {
    event.preventDefault();
    setDragActive(true);
  };

  const handleDragLeave = () => {
    setDragActive(false);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setDragActive(false);
    if (event.dataTransfer.files && event.dataTransfer.files.length > 0) {
      addFiles(event.dataTransfer.files);
      event.dataTransfer.clearData();
    }
  };

  // Remover arquivo
  const handleRemoveFile = (index) => {
    setFiles((prev) => prev.filter((_, i) => i !== index));
  };

  // Enviar
  const handleUpload = async () => {
    setUploading(true);

    const totalSize = files.reduce((total, file) => total + file?.size, 0);
    const maxSize = 20 * 1024 * 1024; // 20MB em bytes

    if (totalSize > maxSize) {
      setSnackbar({
        severity: "warning",
        children: `Tamanho total dos arquivos (${(
          totalSize /
          (1024 * 1024)
        )?.toFixed(2)}MB) excede o limite de 20MB.`,
      });
      setUploading(false);
      return;
    }

    const formData = new FormData();

    files.forEach((file) => {
      formData.append("files", file);
    });

    formData.append("idAtendimento", idAtendimento);

    try {
      const response = isCliente
        ? await apiCliente.post(`/cliente/add/anexos`, formData)
        : await api.post(`/interno/add/anexos`, formData);
      setTicketDetails((prevDetails) => ({
        ...prevDetails,
        anexos: response?.data,
      }));
      setSnackbar({
        severity: "success",
        children: "Arquivos enviados com sucesso!",
      });
      setFiles([]);
      setIsAddAnexo(false); // Movemos para cá para fechar apenas no sucesso, ou mantenha no finally
    } catch (error) {
      console.error("ERRO NO UPLOAD:", error);
      setSnackbar({
        severity: "error",
        children: "Erro ao enviar arquivos. Tente novamente.",
      });
    } finally {
      setUploading(false);
      // setIsAddAnexo(false); // Se quiser fechar mesmo com erro, mantenha aqui
    }
  };

  return (
    <Box sx={styles.containerComponent}>
      <CardContent>
        <FileDropzone
          files={files}
          dragActive={dragActive}
          setDragActive={setDragActive}
          inputId="fileInput"
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
          onFileChange={handleFileChange}
          onRemoveFile={handleRemoveFile}
        />

        <Stack spacing={2} justifyContent={"end"} direction={"row"}>
          <Button disabled={uploading} onClick={() => setIsAddAnexo(false)}>
            Cancelar
          </Button>
          <LoadingButton
            variant="contained"
            loading={uploading}
            endIcon={<SendIcon />}
            onClick={handleUpload}
            disabled={files.length === 0 || uploading}
            sx={{ textTransform: "none" }}
          >
            Anexar arquivos
          </LoadingButton>
        </Stack>
      </CardContent>
    </Box>
  );
}